import { render } from "./loginComponent.vue?vue&type=template&id=24639138&class=bodyC"
import script from "./loginComponent.vue?vue&type=script&lang=js"
export * from "./loginComponent.vue?vue&type=script&lang=js"

import "./loginComponent.vue?vue&type=style&index=0&id=24639138&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__